export const YYYY_MM_DD = "YYYY/MM/DD";
export const YYYY_MM_DD_ALTERNATIVE = "YYYY-MM-DD";
export const MM_DD_YYYY = "MM/DD/YYYY";
export const MM_DD_YYYY_ALTERNATIVE = "MM - dd - yyyy";
